import {} from './money.js';
/**
 * Asset economics (spec §3.5, sheets "House" / "Charger" / "Græstoftevej").
 *
 * An asset is a thing the user owns whose value tracks separately from consumption:
 *  - market value (`currentValue`) is what it's worth today,
 *  - cost basis is what has been sunk into it — the purchase price plus every capex
 *    cost line (renovation, parts, roof …). Cost lines are *asset-converting* outflows:
 *    they raise the basis, they are not consumption.
 *  - an optional linked loan is a liability secured against the asset.
 *
 * Net worth counts the market value as an asset and the linked loan's outstanding balance
 * as a liability, so the user's stake in the thing is:  equity = market value − loan.
 */
/** Cost basis = purchase price + Σ cost lines (all capex sunk into the asset). */
export function costBasis(purchasePrice, costLines) {
    return costLines.reduce((sum, c) => sum + c, purchasePrice);
}
/**
 * Equity in an asset = market value − outstanding linked-loan balance.
 * The loan is 0 when nothing is linked; a market value below the loan yields negative
 * equity (under water), which is a real state we surface rather than clamp.
 */
export function assetEquity(currentValue, linkedLoanOutstanding) {
    return currentValue - linkedLoanOutstanding;
}
/**
 * Appreciation of the asset measured against its cost basis (not the purchase price alone):
 * market value − (purchase price + Σ cost lines). Positive = the thing is worth more than
 * everything sunk into it; negative = it has depreciated / the reno hasn't paid back yet.
 */
export function appreciation(currentValue, costBasisOre) {
    return currentValue - costBasisOre;
}
//# sourceMappingURL=asset.js.map